import React, { useState } from 'react';
import { Button, Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CrazyCookieConsent = () => {
  const { t } = useTranslation();
  const [showConsent, setShowConsent] = useState(true);

  const handleAcceptCookies = () => {
    setShowConsent(false);
    localStorage.setItem('cookieConsent', 'true');
  };

  if (!showConsent) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        animation: 'wiggle 1.5s ease-in-out infinite'
      }}
    >
      <Paper
        elevation={12}
        sx={{
          width: { xs: '90%', sm: '70%', md: '50%' },
          maxWidth: 400,
          padding: 4,
          backgroundColor: '#233240',
          color: '#fff',
          textAlign: 'center',
          borderRadius: '16px',
          animation: 'bounce 2s ease infinite'
        }}
      >
        <Typography variant="h6" gutterBottom>
          {t('cookieConsent.message')}
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleAcceptCookies}
          sx={{
            fontSize: '1.2rem',
            marginTop: 2,
            backgroundColor: '#ff5722',
            '&:hover': { backgroundColor: '#ff7043' }
          }}
        >
          {t('cookieConsent.accept')}
        </Button>
      </Paper>

      <style jsx>{`
        @keyframes wiggle {
          0% { transform: rotate(-5deg); }
          50% { transform: rotate(5deg); }
          100% { transform: rotate(-5deg); }
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-15px); }
        }
      `}</style>
    </Box>
  );
};

export default CrazyCookieConsent;
